import React, { useState, createContext } from "react";
import { useTranslation } from "react-i18next";

import JobRoleDetailTreeModal from "./JobRoleDetailTreeModal";
const jobRoleDetailsContext = createContext();
export default function JobRoleDetails({
  children,
  onChange,
  searchObject,
  techAreas,
  techRoles,

  techAreaFieldName = "techAreaId",
  techRoleFieldName = "techRoleId"
}) {
  let { t } = useTranslation();
  const [helperOpen, setHelperOpen] = useState(false);
  function onCloseHellper() {
    setHelperOpen(false);
  }
  return (
    <jobRoleDetailsContext.Provider value={{ setHelperOpen }}>
      {children ? (
        children
      ) : (
        <>
          <div className="form-group " style={{marginTop:"10px"}}>
            <div className="row">
              {" "}
              <label className="form-label col">
                {t("Professional Category")}
              </label>
              <a
                className="col text-end"
                href="#"
                onClick={() => setHelperOpen(true)}
              >
                {t("View Categorization")}
              </a>
            </div>

            <select
              id="techAreaId"
              name={techAreaFieldName || "techAreaId"}
              className="form-select"
              onChange={onChange}
              value={searchObject[techAreaFieldName] || ""}
              title={t("Selecione um item da lista.")}
              required
            >
              <option value="" selected>
                {t("Select Professional Category...")}
              </option>
              {techAreas.map((item) => (
                <option key={item.id} value={item.id}>
                  {t(item.description)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group ">
            <label className="form-label">{t("Role")}</label>
            <select
              id="techRoleId"
              name={techRoleFieldName || "techRoleId"}
              className="form-select"
              onChange={onChange}
              value={searchObject[techRoleFieldName] || ""}
              title={t("Selecione um item da lista.")}
            >
              <option value="" selected>
                {t("Select  Role...")}
              </option>
              {techRoles?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.description}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
      <JobRoleDetailTreeModal
        isOpen={helperOpen}
        onClose={onCloseHellper}
        setJobRoleDetails={onChange}
        jobRoleDetails={searchObject}
        techRoleFieldName={techRoleFieldName}
        techAreaFieldName={techAreaFieldName}
      />
    </jobRoleDetailsContext.Provider>
  );
}

export function useJobRoleDetailsContext() {
  return React.useContext(jobRoleDetailsContext);
}
